import { createSelector } from "reselect";

const newEntityState = (state) => {
  if (state && state.newEntity) {
    return state.newEntity;
  }
  return null;
};

const newEntitySelector = createSelector(
  [newEntityState],
  (state) => state //return newEntity
);

const createNewEntitySelector = createSelector(
  [newEntitySelector],
  (state) => state.createEntity
);

const createNewObjectSelector = createSelector(
  [newEntitySelector],
  (state) => state.createObject
);

const postcodeSelector= createSelector(
  [newEntitySelector],
  (state) => state.postcode

)

export const createEntity = createSelector(
  [createNewEntitySelector, createNewObjectSelector, postcodeSelector],
  (createEntity, createObject, postcode) => {
    const addressPostcode = postcode && postcode.postcodeAddress
      ? postcode.postcodeAddress
      : [];
    if (createEntity && createEntity.create.entity) {
      return {
        type: "entity",
        create: createEntity.create.entity,
        id: createEntity.create.entity.id,
        addressPostcode,
      };
    }

    if (createObject && createObject.create.object) {
      return {
        type: "object",
        create: createObject.create.object,
        id: createObject.create.object.id,
      };
    }
    return {
      addressPostcode,
    };
  }
);
